import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import TenantDataGrid from '../TenantDataGrid/TenantDataGrid';
import TenantList from '../TenantList/TenantList';

const Tenants: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <TenantDataGrid />
      </If>
      <If condition={!isDesktop}>
        <TenantList />
      </If>
    </>
  );
};

export default React.memo(Tenants);